import { render, staticRenderFns } from "./quillcustom.vue?vue&type=template&id=42089c8c"
import script from "./quillcustom.vue?vue&type=script&lang=js"
export * from "./quillcustom.vue?vue&type=script&lang=js"
import style0 from "./quillcustom.vue?vue&type=style&index=0&id=42089c8c&prod&lang=styl"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports